module.exports = __webpack_public_path__ + "img/py.8735f1c.webp";